// src/components/ui/loading/LoadingScreen.jsx
import React from 'react';
import { Spinner } from '../spinner';
import { cn } from '../../../utils/cn';

const LoadingScreen = ({
  message = "Loading...",
  icon: Icon = null,
  size = 'default', // 'sm', 'default', 'lg'
  variant = 'default', // 'default', 'emerald', 'blue', 'purple', 'slate'
  fullPage = true,
  className = ''
}) => {
  // Size configurations
  const sizeClasses = {
    sm: 'size-6',
    default: 'size-8',
    lg: 'size-12'
  };

  // Variant color configurations
  const variantClasses = {
    default: {
      spinner: 'text-blue-500',
      icon: 'text-blue-400',
      text: 'text-slate-300'
    },
    emerald: {
      spinner: 'text-emerald-500',
      icon: 'text-emerald-400',
      text: 'text-slate-300'
    },
    blue: {
      spinner: 'text-blue-500',
      icon: 'text-blue-400',
      text: 'text-slate-300'
    },
    purple: {
      spinner: 'text-purple-500',
      icon: 'text-purple-400',
      text: 'text-slate-300'
    },
    slate: {
      spinner: 'text-slate-400',
      icon: 'text-slate-300',
      text: 'text-slate-400'
    }
  };

  const colors = variantClasses[variant] || variantClasses.default;
  const spinnerSize = sizeClasses[size] || sizeClasses.default;

  const containerClasses = cn(
    fullPage ? 'min-h-screen' : 'min-h-[400px]',
    'flex items-center justify-center p-6',
    className
  );

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center justify-center gap-4">
        {/* Spinner with optional icon */}
        <div className="relative">
          <Spinner className={cn(spinnerSize, colors.spinner)} />
          {Icon && (
            <Icon
              className={cn(
                'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
                size === 'sm' ? 'size-3' : size === 'lg' ? 'size-6' : 'size-4',
                colors.icon
              )}
            />
          )}
        </div>

        {/* Loading message */}
        {message && (
          <p className={cn(
            'text-center',
            size === 'sm' ? 'text-sm' : size === 'lg' ? 'text-xl' : 'text-base',
            colors.text
          )}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;
